<template>
  <div class="mt-3">
    <h2 class="fw-bold">
      <router-link to="/relatorios" class="text-teal" title="Relatórios">
        Relatórios
      </router-link>
      <span class="text-gray">/ Totais por Centro de Custo</span>
    </h2>
  </div>
  <div class="card border-start border-start-width-3 border-start-teal">
    <form @submit.prevent="seach">
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-6">
            <select
              class="form-select select2"
              v-model="v$.filters.codCCustoPai.$model"
              v-select2
            >
              <option value="" disabled>
                Selecione um Centro de Custo (Pai)
              </option>
              <option value="Todos" title="Todos">Todos</option>
              <option
                v-for="(centroCustoPai, index) in centrosCustosPais"
                :key="index"
                :value="centroCustoPai.codCCustoPai"
                :title="`${centroCustoPai.codCCustoPai} - ${centroCustoPai.nomeCCustoPai}`"
              >
                {{ centroCustoPai.codCCustoPai }} -
                {{ centroCustoPai.nomeCCustoPai }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <select
              class="form-select select2"
              v-model="v$.filters.orcamentoId.$model"
              v-select2
            >
              <option value="" disabled>Selecione o Ano</option>
              <option
                v-for="orcamento in orcamentos"
                :key="orcamento.id"
                :value="orcamento.id"
                :title="orcamento.ano"
              >
                {{ orcamento.ano }}
              </option>
            </select>
          </div>
          <div class="col-md-2">
            <button
              type="submit"
              class="btn btn-success w-100"
              title="Buscar"
              :disabled="v$.$invalid || loadData"
            >
              <span v-if="loadData">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>Buscar</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <LoadingData v-if="loadData" />
  <TotaisCentroCustoResult v-if="reports.centrosCustos" :reports="reports" />
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import TotaisCentroCustoResult from '@/components/relatorios/TotaisCentroCustoResult.vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import select2 from 'select2'

export default {
  name: 'TotaisCentroCusto',

  components: {
    LoadingData,
    TotaisCentroCustoResult,
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      centrosCustosPais: [],
      orcamentos: [],
      filters: {
        codCCustoPai: '',
        orcamentoId: '',
      },
      reports: {},
      loadData: false,
    }
  },

  methods: {
    async getCentrosCustosPais() {
      try {
        this.centrosCustosPais = await this.$store.dispatch(
          'getCentrosCustosPais',
        )
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getOrcamentos() {
      try {
        this.orcamentos = await this.$store.dispatch('getOrcamentos')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async seach() {
      if (!this.v$.$invalid) {
        this.loadData = true
        try {
          this.reports = {}

          this.reports = await this.$store.dispatch(
            'relTotaisCentroCusto',
            this.filters,
          )

          this.loadData = false
        } catch (error) {
          this.loadData = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      filters: {
        codCCustoPai: {
          required,
        },
        orcamentoId: {
          required,
        },
      },
    }
  },

  mounted() {
    this.getCentrosCustosPais()
    this.getOrcamentos()

    window.$('.select2').select2({ width: '100%' })
  },
}
</script>
